import React from "react";
import { Box, VStack, Heading, Text, Link, SimpleGrid, Button, Icon } from "@chakra-ui/react";
import { FaBriefcase, FaUniversity, FaHandHoldingUsd } from "react-icons/fa";

const provincesAndTerritories = [
  "Ontario",
  "Alberta",
  "British Columbia",
  "Manitoba",
  "Saskatchewan",
  "Nova Scotia",
  "New Brunswick",
  "Newfoundland and Labrador",
];

const slugify = (value) => value.toLowerCase().replace(/\s+/g, "-");

const provinceRouteOverrides = {
  Ontario: "/ontario-eligibility",
  Alberta: "/alberta-eligibility",
  "British Columbia": "/british-columbia-eligibility",
  Manitoba: "/manitoba-eligibility",
  Saskatchewan: "/saskatchewan-eligibility",
  "Nova Scotia": "/nova-scotia-eligibility",
  "New Brunswick": "/new-brunswick-eligibility",
  "Newfoundland and Labrador": "/newfoundland-and-labrador-eligibility",
};

export default function EligibilityPage() {
  return (
    <Box
      width="100%"
      bg="gray.50"
      pt={{ base: 28, md: 32 }}
      pb={{ base: 12, md: 16 }}
      px={{ base: 4, md: 8 }}
    >
      <VStack maxW="1100px" mx="auto" spacing={8} align="stretch">
        <Box
          border="1px solid"
          borderColor="blue.100"
          borderRadius="2xl"
          px={{ base: 5, md: 8 }}
          py={{ base: 8, md: 10 }}
          bgGradient="linear(to-r, blue.50, white)"
          boxShadow="sm"
        >
          <VStack spacing={3} textAlign="center">
            <Heading size="xl">Who qualifies for Swift Credit loans?</Heading>
            <Text color="gray.700" maxW="920px" lineHeight="1.8">
            Swift Credit offers cash loans to customers who receive either employment income or government subsidies and benefits. At Swift Credit, we believe every Canadian — newcomers, permanent residents, and citizens — deserves a fair opportunity to build or rebuild credit. Poor or limited credit history does not automatically disqualify you.
            </Text>
          </VStack>
        </Box>

        <VStack spacing={5} align="stretch">
          <Box
            border="1px solid"
            borderColor="gray.200"
            borderRadius="xl"
            p={{ base: 5, md: 6 }}
            bg="white"
            boxShadow="sm"
            _hover={{ boxShadow: "md", borderColor: "gray.300" }}
            transition="all 0.2s ease"
          >
            <VStack align="stretch" spacing={3}>
              <VStack spacing={3} align="center" textAlign="center">
                <Box
                  w="46px"
                  h="46px"
                  borderRadius="full"
                  bg="blue.50"
                  border="1px solid"
                  borderColor="blue.200"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Icon as={FaBriefcase} color="blue.700" boxSize={5} />
                </Box>
                <Heading size="md">Short-term loans for employment income earners</Heading>
              </VStack>
              <Text color="gray.700" lineHeight="1.8">
              To qualify, you must have been employed for at least 3 months. We offer unsecured loans from $500 to $20,000, based on your income profile. You can choose a repayment period between 12 and 48 months.
              </Text>
            </VStack>
          </Box>

          <Box
            border="1px solid"
            borderColor="gray.200"
            borderRadius="xl"
            p={{ base: 5, md: 6 }}
            bg="white"
            boxShadow="sm"
            _hover={{ boxShadow: "md", borderColor: "gray.300" }}
            transition="all 0.2s ease"
          >
            <VStack align="stretch" spacing={3}>
              <VStack spacing={3} align="center" textAlign="center">
                <Box
                  w="46px"
                  h="46px"
                  borderRadius="full"
                  bg="blue.50"
                  border="1px solid"
                  borderColor="blue.200"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Icon as={FaUniversity} color="blue.700" boxSize={5} />
                </Box>
                <Heading size="md">Short-term loans for customers receiving government subsidies</Heading>
              </VStack>
              <Text color="gray.700" lineHeight="1.8">
              To qualify, you must be receiving an eligible government subsidy in your province. This may include Employment Insurance (EI), pension payments, Canada Child Benefit (CCB), and other approved programs.
              </Text>
              <Text color="gray.700" lineHeight="1.8">
              We offer unsecured loans from $500 to $20,000, based on your income profile. Government subsidy loans have a 12-month repayment period.
              </Text>
              <Text color="gray.700" fontWeight="600">
              Click on your province or territory to view accepted subsidies:
              </Text>
            </VStack>
            <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={2} mt={4}>
              {provincesAndTerritories.map((location) => (
                <Link
                  key={location}
                  href={provinceRouteOverrides[location] || `/eligibility?province=${slugify(location)}`}
                  color="blue.700"
                  fontWeight="600"
                  border="1px solid"
                  borderColor="blue.200"
                  borderRadius="full"
                  px={4}
                  py={2}
                  textAlign="center"
                  bg="blue.50"
                  _hover={{ color: "blue.800", bg: "blue.100", textDecoration: "none" }}
                >
                  {location}
                </Link>
              ))}
            </SimpleGrid>
          </Box>

         {/* <Box
            border="1px solid"
            borderColor="gray.200"
            borderRadius="xl"
            p={{ base: 5, md: 6 }}
            bg="white"
            boxShadow="sm"
            _hover={{ boxShadow: "md", borderColor: "gray.300" }}
            transition="all 0.2s ease"
          >
            <VStack align="stretch" spacing={3}>
              <VStack spacing={3} align="center" textAlign="center">
                <Box
                  w="46px"
                  h="46px"
                  borderRadius="full"
                  bg="blue.50"
                  border="1px solid"
                  borderColor="blue.200"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Icon as={FaHandHoldingUsd} color="blue.700" boxSize={5} />
                </Box>
                <Heading size="md">Payday loan ($100 to $1,500)</Heading>
              </VStack>
              <Text color="gray.700" lineHeight="1.8">
              We offer small loans of $100 to $1,500 to customers who receive either employment income or eligible government subsidies. This loan is repaid within 42 to 62 days.
              </Text>
              <Text color="gray.700" lineHeight="1.8">
              This option is currently available to residents of Ontario, Alberta, British Columbia.
              </Text>
              <Text color="gray.700" lineHeight="1.8">
                For additional information, see our <Link href="/#faq-section" color="blue.700" fontWeight="600">FAQ</Link> or <Link href="/help" color="blue.700" fontWeight="600">contact us</Link>.
              </Text>
            </VStack>
          </Box> */}
        </VStack>

        <Box textAlign="center" pt={3}>
          <Button
            as="a"
            href="/apply"
            bg="black"
            color="white"
            borderRadius="full"
            minW={{ base: "220px", md: "300px" }}
            h="52px"
            fontWeight="700"
            _hover={{ bg: "gray.900" }}
          >
            Apply now
          </Button>
        </Box>
      </VStack>
    </Box>
  );
}
